<select #selfSort (change)="update(selfSort.value)" class="text-xs md:text-sm bg-ponder outline-none w-full p-1 pb-[5px] border border-transparent focus:border-ponder-bright text-slate-200 ">
    @for (kvp of getOptions() ; track kvp[0] ; let index = $index) {
        <option value="{{ kvp[0] }}">{{ kvp[0] }}</option>
    }
</select>